// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OcjenaTooltip_tooltipContainer__WPtmL {
  position: relative;
  display: inline-block;
}

.OcjenaTooltip_tooltip__wQYfr {
  position: absolute;
  height: 200px;
  width: 400px;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 7px 7px 75px 0px #5f6d7e1a;
  color: rgb(0, 0, 0);
  text-align: center;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.OcjenaTooltip_tooltipContainer__WPtmL:hover .OcjenaTooltip_tooltip__wQYfr {
  opacity: 1;
}

.OcjenaTooltip_tooltipContainer__WPtmL:hover {
  text-decoration: underline;
  cursor: pointer;
}

.OcjenaTooltip_firstRow__xuNzU {
  display: flex;
  gap: 10px;
  align-items: center;
}

.OcjenaTooltip_ocjena__Xo91g,
.OcjenaTooltip_progress__x-wxC {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.OcjenaTooltip_averageOcjena__QTlXd,
.OcjenaTooltip_ocjenaName__ZU8eX {
  font-family: "Inter";
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}

.OcjenaTooltip_ukupnoOcjene__K4r27,
.OcjenaTooltip_dot__FI\\+jG,
.OcjenaTooltip_ocjenaCount__McYyT {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 14.52px;
  text-align: left;
  color: #95999e;
}

.OcjenaTooltip_dot__FI\\+jG {
  font-size: 25px;
  opacity: 0.5;
}

.OcjenaTooltip_averageOcjena__QTlXd {
  font-size: 20;
}

.OcjenaTooltip_ocjenaName__ZU8eX,
.OcjenaTooltip_progress__x-wxC {
  width: 50%;
}

.OcjenaTooltip_progressBar__KhHAO {
  width: 144px;
  background-color: #d9d9d9;
}
.OcjenaTooltip_orangeBar__Y0OxH {
  height: 4px;
  background-color: #cb9c2d;
}
`, "",{"version":3,"sources":["webpack://./src/components/OcjenaTooltip/OcjenaTooltip.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".tooltipContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip {\n  position: absolute;\n  height: 200px;\n  width: 400px;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  padding: 20px;\n  background-color: rgb(255, 255, 255);\n  box-shadow: 7px 7px 75px 0px #5f6d7e1a;\n  color: rgb(0, 0, 0);\n  text-align: center;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 1000;\n  opacity: 0;\n  transition: opacity 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.tooltipContainer:hover .tooltip {\n  opacity: 1;\n}\n\n.tooltipContainer:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.firstRow {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.ocjena,\n.progress {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.averageOcjena,\n.ocjenaName {\n  font-family: \"Inter\";\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n\n.ukupnoOcjene,\n.dot,\n.ocjenaCount {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14.52px;\n  text-align: left;\n  color: #95999e;\n}\n\n.dot {\n  font-size: 25px;\n  opacity: 0.5;\n}\n\n.averageOcjena {\n  font-size: 20;\n}\n\n.ocjenaName,\n.progress {\n  width: 50%;\n}\n\n.progressBar {\n  width: 144px;\n  background-color: #d9d9d9;\n}\n.orangeBar {\n  height: 4px;\n  background-color: #cb9c2d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `OcjenaTooltip_tooltipContainer__WPtmL`,
	"tooltip": `OcjenaTooltip_tooltip__wQYfr`,
	"firstRow": `OcjenaTooltip_firstRow__xuNzU`,
	"ocjena": `OcjenaTooltip_ocjena__Xo91g`,
	"progress": `OcjenaTooltip_progress__x-wxC`,
	"averageOcjena": `OcjenaTooltip_averageOcjena__QTlXd`,
	"ocjenaName": `OcjenaTooltip_ocjenaName__ZU8eX`,
	"ukupnoOcjene": `OcjenaTooltip_ukupnoOcjene__K4r27`,
	"dot": `OcjenaTooltip_dot__FI+jG`,
	"ocjenaCount": `OcjenaTooltip_ocjenaCount__McYyT`,
	"progressBar": `OcjenaTooltip_progressBar__KhHAO`,
	"orangeBar": `OcjenaTooltip_orangeBar__Y0OxH`
};
export default ___CSS_LOADER_EXPORT___;
